import _classCallCheck from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/usr/src/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import { ExtensionMessage } from "./models/extensionMessage.js";
import { ExtensionMessageType } from "./models/extensionMessageType.js";
export var ExtensionClient = /*#__PURE__*/function () {
  function ExtensionClient() {
    var _this = this;
    _classCallCheck(this, ExtensionClient);
    window.addEventListener('message', function (event) {
      return _this.onHandshakeReceived(event, _this);
    }, {
      once: true
    }); // Once option sets this handler only once for the handshake 
  }
  _createClass(ExtensionClient, [{
    key: "executionComplete",
    value: function executionComplete(encryptedPayload) {
      if (!this.messagePort) {
        throw new Error('Handshake has not been completed!');
      }
      var request = new ExtensionMessage(ExtensionMessageType.ExecutionComplete, encryptedPayload);
      this.messagePort.postMessage(request);
    }
  }, {
    key: "onHandshakeReceived",
    value: function onHandshakeReceived(event, client) {
      switch (event.data.type) {
        case ExtensionMessageType.Handshake:
          client.Handshake(event);
          break;
        default:
          throw new Error("Message type '".concat(event.data.type, "' not allowed!"));
      }
      ;
    }
  }, {
    key: "Handshake",
    value: function Handshake(event) {
      this.messagePort = event.ports[0];
      this.messagePort.onmessage = this.onMessageReceived;
      this.encryptedExtensionContext = event.data.encryptedPayload;
      var onContextReceivedEvent = new CustomEvent(ExtensionClient.onContextReceived, {
        detail: this.encryptedExtensionContext
      });
      document.dispatchEvent(onContextReceivedEvent);
    }
  }, {
    key: "onMessageReceived",
    value: function onMessageReceived(event) {
      // Subsequent message coming from the Imagine App (iframe parent)
      var onMessageReceivedEvent = new CustomEvent(ExtensionClient.onMessageReceived, {
        detail: event.data.encryptedPayload
      });
      document.dispatchEvent(onMessageReceivedEvent);
    }
  }]);
  return ExtensionClient;
}();
ExtensionClient.onContextReceived = "onContextReceived";
ExtensionClient.onMessageReceived = "onMessageReceived";